// see https://cloud.google.com/storage/docs/retry-strategy
export const isRetryableHttpStatus = (status: number): boolean =>
  status === 408 || status === 429 || (status >= 500 && status < 600);
